import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeHiphen' })
export class RemoveHiphenPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value.replace(/-/g, " ");
  }
}
